import React from "react";

const ENTRY_TYPES = [
  { value: "activity", label: "Activity", icon: "location_on", color: "bg-blue-500" },
  { value: "transport", label: "Transport", icon: "directions_bus", color: "bg-green-500" },
  { value: "hotel", label: "Hotel", icon: "hotel", color: "bg-amber-500" },
  { value: "meal", label: "Meals", icon: "restaurant", color: "bg-orange-500" },
];

const EntryTypeSelector = ({ value, onChange, disabled }) => {

  return (
		<div
			className={`flex gap-1 p-0.5 rounded-md ${disabled ? "" : "bg-gray-100"}`}
		>
			{ENTRY_TYPES.map(type => {
				const isActive = value === type.value;
				return (
					<button
						key={type.value}
						type="button"
						disabled={disabled}
						onClick={() => {
							if (!isActive && !disabled) onChange(type.value);
						}}
						className={`flex items-center gap-1 px-2 py-1 rounded text-xs font-medium transition-colors whitespace-nowrap ${
							isActive
								? `${type.color} text-white shadow-sm`
								: "text-gray-500 hover:bg-gray-200 cursor-pointer"
						} ${disabled ? "cursor-default" : ""}`}
					>
						<span
							className="material-symbols-outlined"
							style={{ fontSize: "14px" }}
						>
							{type.icon}
						</span>
						{type.label}
					</button>
				);
			})}
		</div>
	);
};

export default EntryTypeSelector;
